/*
 _____  _____  _____  _      _____  ___    _   _
|  ___||  _  ||_   _|| |    |  _  ||  _|_ | | | |
| |___ | |_| |  | |  | |    | |_| || | | || |_| |
|  ___||  _  |  | |  | |    |  _  || | | ||_   _|
| |    | | | |  | |  | |___ | | | || |_|_|  | |  
|_|    |_| |_|  |_|  |_____||_| |_||___|    |_|   :-)

Created by: Elad Ziv
www.fatlady.co.il

*/
var socialObj = {};
//
socialObj["url"] = {};
socialObj["url"]["facebook"] =
  "https://www.facebook.com/sharer.php?u=[url]&t=[title]";
socialObj["url"]["twitter"] =
  "https://twitter.com/intent/tweet?text=[title] - [text]&url=[url]";
socialObj["url"]["google+"] = "https://plus.google.com/share?url=[url]";
socialObj["url"]["linkedin"] =
  "https://www.linkedin.com/shareArticle?mini=true&url=[url]&title=[title]&summary=[text]";
socialObj["url"]["pinterest"] =
  "https://pinterest.com/pin/create/button/?url=[url]&media=[img]&description=[title]%20-%20[text]";
socialObj["url"]["whatsapp"] = "https://web.whatsapp.com/send?text=[url]";
socialObj["url"]["fb-messanger"] =
  "fb-messenger://share/?link=[url]&app_id=[fbAppId]";
socialObj["url"]["instagram"] = "https://www.instagram.com/?url=[url]";
socialObj["url"]["email"] =
  "mailto:?subject=[title]&body=[text]: \r\n\r\n[url]";
//
socialObj.SHARE_TYPE_MOBILE = "mobile";
socialObj.SHARE_TYPE_FACEBOOK = "facebook";
socialObj.SHARE_TYPE_TWITTER = "twitter";
socialObj.SHARE_TYPE_GOOGLE = "google+";
socialObj.SHARE_TYPE_LINKED_IN = "linkedin";
socialObj.SHARE_TYPE_PINTEREST = "pinterest";
socialObj.SHARE_TYPE_WHATSAPP = "whatsapp";
socialObj.SHARE_TYPE_FB_MASSANGER = "fb-messanger";
socialObj.SHARE_TYPE_INSTAGRAM = "instagram";
socialObj.SHARE_TYPE_EMAIL = "email";
socialObj.SHARE_TYPE_COPY_URL = "copy-url";
//
socialObj["data"] = {};
socialObj["data"]["url"] = "";
socialObj["data"]["title"] = "";
socialObj["data"]["text"] = "";
socialObj["data"]["image"] = "";
socialObj["data"]["fbAppId"] = "";

socialObj.strReplace = function (str, sstr, rstr) {
  return str.split(sstr).join(rstr);
};

socialObj.urlEncode = function (str) {
  str = escape(str);
  str = socialObj.strReplace(str, "/", "%2f");
  return str;
};

socialObj.copyToClipboard = function(str) {
  var el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.width = '1px';
  el.style.height = '1px';
  el.style.left = '-999px';
  el.style.top = '-999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  //
  var dirLtr = document.documentElement.getAttribute('dir') === 'ltr';
  var copyText = dirLtr ? 'URL copied to clipboard' : 'כתובת הדף הועתקה ללוח';
  //
  el = document.createElement('div');
  el.innerHTML = copyText;
  document.body.appendChild(el);
  el.style.display = 'block';
  el.style.position = 'fixed';
  el.style.opacity = 0;
  el.style.left = '50%';
  el.style.top = '50%';
  el.style.zIndex = '999999';
  el.style.fontSize = '0.75rem';
  el.style.padding = '0.25em 0.5em';
  el.style.backgroundColor = 'rgba(255,255,255,.85)';
  el.style.color = '#000';
  el.style.transform = 'translate(-50%,-50%)';
  el.style.borderRadius = '0.75em';
  el.style.pointerEvents = 'none';
  el.style.touchAction = 'none';
  el.style.boxShadow = '0 0 4px rgba(0,0,0,.5)';
  el.style.transition = 'all 150ms linear';
  setTimeout(()=>{el.style.opacity = 1;},33);
  setTimeout(()=>{el.style.opacity = 0;},800);
  setTimeout(()=>{document.body.removeChild(el);},1000);
};

socialObj.doShare = function (type) {
  var url;
  //
  //window.fl.utils.trackGAEvent("social", "share", type);
  //alert(socialObj.data.title + ' ' + socialObj.data.text);
  //
  if (type == "mobile") {
    if (navigator && navigator.share) {
      navigator
        .share({
          title: socialObj["data"]["title"],
          text: socialObj["data"]["title"] + " - " + socialObj["data"]["text"],
          url: socialObj["data"]["url"],
        })
        .then(() => {
          //alert("Success");
        })
        .catch((e) => {
          console.error("Share failed");
          //alert("Share failed");
        });
    } else {
      console.error("Mobile share unavailable");
      //alert("Mobile share unavailable");
    }
  } else if (type == "copy-url") {
    socialObj.copyToClipboard(socialObj["data"]["url"]);
  } else if (type == "email") {
    url = socialObj["url"][type];
    url = socialObj.strReplace(
      url,
      "[url]",
      socialObj.urlEncode(socialObj["data"]["url"])
    );
    url = socialObj.strReplace(url, "[title]", socialObj["data"]["title"]);
    url = socialObj.strReplace(url, "[text]", socialObj["data"]["text"]);
    //window.location=url;
    window.open(url, "social", "width=500,height=500,scrollbars=auto");
  } else {
    url = socialObj["url"][type];
    url = socialObj.strReplace(
      url,
      "[url]",
      socialObj.urlEncode(socialObj["data"]["url"])
    );
    url = socialObj.strReplace(url, "[title]", socialObj["data"]["title"]);
    url = socialObj.strReplace(url, "[text]", socialObj["data"]["text"]);
    url = socialObj.strReplace(
      url,
      "[img]",
      socialObj.urlEncode(socialObj["data"]["image"])
    );
    url = socialObj.strReplace(url, "[fbAppId]", socialObj["data"]["fbAppId"]);
    //
    if (type === "fb-messanger" && !socialObj["data"]["fbAppId"].length) {
      return false;
    }
    //
    window.open(url, "social", "width=500,height=250,scrollbars=auto");
  }
};

socialObj.setData = function (linkUrl, title, text, image, fbAppId) {
  socialObj["data"]["url"] = linkUrl;
  socialObj["data"]["title"] = title;
  socialObj["data"]["text"] = text;
  socialObj["data"]["image"] = image;
  socialObj["data"]["fbAppId"] = fbAppId;
};

socialObj.share = function (shareType, linkUrl, title, text, image, fbAppId) {
  socialObj.setData(linkUrl, title, text, image, fbAppId);
  //
  socialObj.doShare(shareType);
};

socialObj.pageShare = function (shareType, linkUrl, extraParams) {
  // var linkUrl = window.location.href;
  var title = "";
  var text = "";
  var image = "";
  var fbAppId = "";
  //
  if (extraParams && typeof extraParams == "object") {
    if (linkUrl.indexOf("?") > -1) {
      var query = window.fl.getUrlParams() || {};
      for (var key in extraParams) {
        query[key] = extraParams[key];
      }
      var queryStr = "";
      for (var key in query) {
        if (queryStr != "") {
          queryStr += "&";
        }
        queryStr += key + "=" + query[key];
      }
      linkUrl = linkUrl.split("?")[0] + "?" + queryStr;
      //trace('linkUrl',linkUrl);
    }
  }
  //
  for (var i = 0; i < $("head").find("meta").length; i++) {
    var prop = $($("head").find("meta")[i]).attr("property");
    var content = $($("head").find("meta")[i]).attr("content");
    //
    if (prop === "og:title") {
      title = content;
    } else if (prop === "og:description") {
      text = content;
    } else if (prop === "og:image") {
      image = content;
    } else if (prop === "fb:app_id") {
      fbAppId = content;
    }
    //trace(shareType+', '+linkUrl+', '+title+', '+text+', '+image+', '+fbAppId);
  }
  //
  let getFilters = new URL(location).searchParams.get("filter");
  if(getFilters) {
    tempUrl = new URL(linkUrl);
    tempUrl.searchParams.set('filter', getFilters);
    linkUrl = tempUrl.href;
  }
  socialObj.share(shareType, linkUrl, title, text, image, fbAppId);
};

window.fl = window.fl || {};
window.fl["social"] = window.fl["social"] || {};
window.fl.social = socialObj;
